module.exports = {"522632100":"古州镇","522632101":"忠诚镇","522632102":"寨蒿镇","522632103":"平永镇","522632104":"乐里镇","522632105":"朗洞镇","522632106":"栽麻镇","522632107":"平江镇","522632108":"八开镇","522632202":"崇义乡","522632204":"三江水族乡","522632205":"仁里水族乡","522632206":"塔石瑶族水族乡","522632208":"定威水族乡","522632209":"兴华水族乡","522632210":"计划乡","522632211":"水尾水族乡","522632212":"平阳乡","522632213":"两汪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522632.json
// module id = 2333
// module chunks = 0